import React from 'react';
import { connect } from 'react-redux';
import { Sidebar } from '@saucelabs/ds-navigation';
import Button from '@saucelabs/ds-button';
import config from '@saucelabs/sl-util-config';
import { Typography } from '@saucelabs/ds-typography';

import * as actions from '../ducks/dashboard-container-new/actions';
import { DashboardContainerNewState } from '../ducks/dashboard-container-new/reducers';

const { apiBaseUrls, loginPageFullPath } = config;

export const UnAuthenticatedSidebarNew = (props: UnAuthenticatedSidebarNewProps) => {
  const { isMobileCollapsed, closeMobileMenu } = props;
  return (
    <Sidebar
      closeMobileMenu={closeMobileMenu}
      content={(
        <div className="px-2 py-4 flex flex-col text-center space-y-2">
          <Typography variant="heading-4">Enhance the value of your CI workflow</Typography>
          <Typography
            component="p"
            variant="body"
          >
            Sauce fits into your existing deployment pipeline to help scale your testing and
            pinpoint issues easily across hundreds of platforms.
          </Typography>
          <Button
            block
            component="a"
            href={apiBaseUrls.signup}
          >
            Get Started Free
          </Button>
          <a href={loginPageFullPath}>Already a member? Log in</a>
        </div>
      )}
      isCollapsed={false}
      isMobileCollapsed={isMobileCollapsed}
    />
  );
};

export interface UnAuthenticatedSidebarNewProps {
  isMobileCollapsed: boolean;
  closeMobileMenu: () => void;
}

const mapStateToProps = (state: {dashboard: DashboardContainerNewState}) => ({
  isMobileCollapsed: state.dashboard.isMobileCollapsed,
});
const mapDispatchToProps = {
  closeMobileMenu: actions.closeMobileMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnAuthenticatedSidebarNew);
